/* eslint-disable */

export interface IntrospectionResultData {
  __schema: {
    types: {
      kind: string;
      name: string;
      possibleTypes: {
        name: string;
      }[];
    }[];
  };
}
const result: IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: 'INTERFACE',
        name: 'PaymentMethod',
        possibleTypes: [
          {
            name: 'CreditCardPaymentMethod',
          },
          {
            name: 'PointsPaymentMethod',
          },
          {
            name: 'VoucherPaymentMethod',
          },
          {
            name: 'CreditNotePaymentMethod',
          },
          {
            name: 'QantasGroupCreditVoucherPaymentMethod',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'BookingPaymentMethod',
        possibleTypes: [
          {
            name: 'CreditCardPaymentMethod',
          },
          {
            name: 'PointsPaymentMethod',
          },
          {
            name: 'VoucherPaymentMethod',
          },
          {
            name: 'CreditNotePaymentMethod',
          },
          {
            name: 'QantasGroupCreditVoucherPaymentMethod',
          },
        ],
      },
    ],
  },
};
export default result;
